import { CheckIcon } from "@/components/ui/icon";
import { Checkbox, CheckboxIndicator, CheckboxIcon } from "@/components/ui/checkbox";
import { Box } from "@/components/ui/box";
import { Avatar, AvatarImage } from "@/components/ui/avatar";
import React, { useState } from 'react';
import i18n from '../../assets/i18n';
import BasicElement from '../basic/BasicElement';
import imgNone from '../../assets/images/missing.png';
import { imageSrc } from '../media/MediaSelector';
import { IconM } from '../media/IconsV2';

export default function ListElement({ idx, element, avatar, updateItem, currentStep, marked, tag, invertTextColor, onYes, onNo, disabled, graph, icon }) {

    const [done, setDone] = useState(element.done)
    const [avatarSrc, setAvatarSrc] = useState(imageSrc(avatar))

    const onChange = newDone => {
        setDone(newDone)
        updateItem({ ...element, done: newDone }, idx)
    }

    return (
        <>
            {icon && <IconM className="absolute top-1 right-1 ml-2 text-sm text-primary-900" name={icon} />}
            <BasicElement
                media={element.media[0]}
                overlay={element?.overlays?.[element.media[0]]}
                prefix={(onYes ? i18n.t('showStep.onYes') + ': ' : onNo ? (i18n.t('showStep.onNo') + ': ') : '')}
                title={(idx == undefined ? (element.changed ? '* ' : '') : (idx + 1) + '. ') + element.title}
                text={element.text}
                selected={invertTextColor}
                disabled={disabled}
                mark1={marked}
                mark2={currentStep}
                graph={graph}
                tag={tag}
                onChange={updateItem ? onChange : null}
            >
                {avatar ?
                    <Box className="border-primary-900 border rounded-full self-end p-0.5">
                        <Avatar size='sm'>
                            <AvatarImage key={avatar} onError={() => setAvatarSrc(imgNone)} source={avatarSrc} alt={i18n.t('global.missingImage')} className="self-end bg-white"></AvatarImage>
                        </Avatar>
                    </Box> :
                    updateItem && <Checkbox key={done} size='lg' value={element.title} isChecked={done} onChange={(e) => onChange(e)} aria-label={element.title} className="w-16 self-end text-primary-900">
                        <CheckboxIndicator className="mr-0 w-12 h-12 text-primary-900 border-primary-900">
                            <CheckboxIcon as={CheckIcon} className="w-11 h-11 bg-primary-900" />
                        </CheckboxIndicator>
                    </Checkbox>}
            </BasicElement>
        </>
    );
}
